<template>
  <div class="card">
    <div
      class="card-box"
      v-for="(item, index) in dataSouce"
      :key="'card' + index"
    >
      <div class="header">
        <span>{{ item.title }}</span>
      </div>
      <img class="icon" v-if="item.icon" :src="item.icon" :alt="item.title">
      <ul class="body">
        <li v-for="(text, i) in item.list" :key="'list' + i">
          {{ text }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: "SolutionCard",
  props:{
    dataSouce:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  data() {
    return {
      
    };
  },
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  justify-content: space-between;

  &-box {
    width: 384px;
    height: 210px;
    background: url("https://cdn.ideamake.cn/sw-pc/images/card-bg.png");
    background-position: center;
    box-shadow: 0px 4px 12px 0px rgba(155,165,192,0.25), inset 0px 1px 3px 0px rgba(0,0,0,0.03);
    text-align: left;
    position: relative;
    &.card-box img{
      display: inline-block;
      width: 81px;
      height: 89px;
    }
     .header {
       height: 50px;
       font-size: 20px;
       font-weight: 500;
       color: #2D2E30;
       padding:26px ;
     
     }
    .body {
      height: 130px;
      margin-top: 22px;
      li {
        position: relative;
        margin: 10px 0 0 42px;
         color: #5A5C60;
      }
      li::after {
        content: "";
        position: absolute;
        left:-14px;
        top:6px;
        display: inline-block;
        width: 8px;
        height: 8px;
       
        border-radius: 50%;
        border: 2px solid #3777f6;
      }
    }
    .icon {
        position: absolute;
        bottom: 20px;
        right: 20px;
      }
   
  }
}

// 移动端布局
@import "@/views/solution/min-solution";
</style>